import React from 'react';
import logo from '../../img/logo-horizontal-positive.svg';
import { classNames } from 'primereact/utils';
import styles from './footer.module.scss'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function Footer() {

    const { t } = useTranslation();

    return (
        <footer className={classNames(styles.footerContainer)}>
            <img className={classNames(styles.footerLogo)} alt="s" src={logo} />
            <div className={classNames(styles.footerLinkImprint)}><Link className={classNames(styles.contextFontSmallL)} to="/imprint">{t('deTranslation.footerImprint.linkText')}</Link></div>
            <div className={classNames(styles.footerLinkData)}><Link className={classNames(styles.contextFontSmallL)} to="/dataprotection">{t('deTranslation.footerDataProtection.linkText')}</Link></div>
            <div className={classNames(styles.footerLinkContact)}><Link className={classNames(styles.contextFontSmallL)} to="/contact">{t('deTranslation.footerContact.linkText')}</Link></div>
        </footer>
    );
}

export default Footer;
